module.exports = __webpack_public_path__ + "static/media/ic_general_energy_gray.aabe018f.svg";